// set in index/html view, from json from c#
// currently in home, and search;
declare const nsCarousel: {
    create(selector: string | HTMLElement, options: object): Array<NSCarouselEntry>;
    determineTrackEnds(options: any, container: HTMLElement, track: HTMLElement, e: any): void;
};
export  interface NSCarouselEntry {

    container: HTMLElement;
    track: HTMLElement;
    slides: NodeListOf<HTMLElement>;
    options: object;

}

export const nsCarouselWrapper = nsCarousel;

export const nsArrivalDeparturePickerOptions = {

    track: ".adp-months-container",
    forward:".btn-next",
    back: ".btn-prev",
    slide: ".calendar",
    trackEndClass: "-is-end",
    trackStartClass: "-is-start",
    invertTrackStartEnd: false 
};